<template>
  <el-dialog :visible.sync="visible" width="650px" :show-close="false" :close-on-click-modal="false"
    custom-class="edit-parking-area-dialog" @close="closeDialog">
    <div class="dialog-header">
      <span class="dialog-title">{{ $t('parkingAreaManage.editTitle') }}</span>
      <i class="el-icon-close dialog-close" @click="visible = false"></i>
    </div>

    <div class="dialog-body">
      <el-form ref="form" :model="editParkingAreaInfo">
        <div class="form-row form-row-num">
          <div class="form-label required">
            <span class="required-mark">*</span>
            <span>{{ $t('parkingAreaManage.parkingNum') }}</span>
            <span class="colon">:</span>
          </div>
          <div class="form-control">
            <el-input v-model.trim="editParkingAreaInfo.num" :placeholder="$t('parkingAreaManage.inputParkingNum')"
              class="form-input" />
          </div>
        </div>

        <div class="form-row form-row-type">
          <div class="form-label required">
            <span class="required-mark">*</span>
            <span>{{ $t('parkingAreaManage.parkingType') }}</span>
            <span class="colon">:</span>
          </div>
          <div class="form-control">
            <el-select v-model="editParkingAreaInfo.typeCd" :placeholder="$t('parkingAreaManage.selectParkingType')"
              class="form-select">
              <el-option v-for="item in parkingTypes" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </div>
        </div>

        <div v-for="(item, index) in editParkingAreaInfo.attrs" :key="index">
          <div class="form-row" :class="'form-row-attr-' + index">
            <div class="form-label" :class="{ required: item.required }">
              <span v-if="item.required" class="required-mark">*</span>
              <span>{{ item.specName }}</span>
              <span class="colon">:</span>
            </div>
            <div class="form-control">
              <el-input v-if="item.specType === '2233'" v-model="item.value" :placeholder="item.specHoldplace"
                class="form-input" />
              <el-select v-if="item.specType === '3344'" v-model="item.value" :placeholder="item.specHoldplace"
                class="form-select">
                <el-option v-for="value in item.values" :key="value.value" :label="value.valueName"
                  :value="value.value" />
              </el-select>
            </div>
          </div>
        </div>

        <div class="form-row form-row-remark">
          <div class="form-label">
            <span>{{ $t('parkingAreaManage.remark') }}</span>
            <span class="colon">:</span>
          </div>
          <div class="form-control">
            <el-input v-model="editParkingAreaInfo.remark" type="textarea" :rows="3"
              :placeholder="$t('parkingAreaManage.remarkPlaceholder')" class="form-input" />
          </div>
        </div>
      </el-form>
    </div>

    <div class="dialog-footer">
      <el-button class="cancel-btn" @click="visible = false">取消</el-button>
      <el-button class="confirm-btn" @click="editParkingArea" :loading="saving">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateParkingArea } from '@/api/car/parkingAreaManageApi'
import { getEffectiveCommunityId } from '@/api/community/communityApi'

export default {
  name: 'EditParkingArea',
  data() {
    return {
      visible: false,
      saving: false,
      editParkingAreaInfo: {
        paId: '',
        num: '',
        typeCd: '',
        remark: '',
        attrs: []
      },
      parkingTypes: [
        { value: '1001', label: this.$t('parkingAreaManage.aboveGround') },
        { value: '2001', label: this.$t('parkingAreaManage.underground') }
      ]
    }
  },
  methods: {
    open(row) {
      this.visible = true
      this.editParkingAreaInfo = JSON.parse(JSON.stringify(row))
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    
    closeDialog() {
      this.$refs.form.resetFields()
    },
    
    async editParkingArea() {
      if (!this.editParkingAreaInfo.num) {
        this.$message.error(this.$t('parkingAreaManage.numRequired'))
        return
      }
      if (!this.editParkingAreaInfo.typeCd) {
        this.$message.error(this.$t('parkingAreaManage.typeRequired'))
        return
      }

      try {
        this.saving = true
        const params = {
          ...this.editParkingAreaInfo,
          communityId: getEffectiveCommunityId(this.editParkingAreaInfo.communityId)
        }

        await updateParkingArea(params)
        this.$message.success(this.$t('common.operationSuccess'))
        this.visible = false
        this.$emit('success')
      } catch (error) {
        console.error('修改停车场失败:', error)
        this.$message.error(this.$t('parkingAreaManage.editFailed'))
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .edit-parking-area-dialog {
    border-radius: 12px;
    overflow: hidden;

    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      padding: 0;
    }
  }

  .dialog-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 66px;
    padding: 0 24px;
    box-sizing: border-box;
    background: #EBF2FA;
    border-bottom: 1px solid #DCE6F5;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;

    .dialog-title {
      font-size: 16px;
      font-family: 'PingFang SC', sans-serif;
      font-weight: 600;
      color: #1D2129;
    }

    .dialog-close {
      font-size: 16px;
      color: #8C9BB4;
      cursor: pointer;

      &:hover {
        color: #1D2129;
      }
    }
  }

  .dialog-body {
    padding: 24px 0 0;

    .form-row {
      display: flex;
      align-items: flex-start;
      margin-bottom: 20px;
      box-sizing: border-box;

      &:last-child {
        margin-bottom: 0;
      }

      .form-label {
        text-align: right;
        padding-top: 9px;
        flex-shrink: 0;
        font-size: 14px;
        font-family: 'PingFang SC', sans-serif;
        font-weight: 500;
        color: #1D2129;
        white-space: nowrap;

        .required-mark {
          color: #FB2C36;
          margin-right: 2px;
        }

        .colon {
          color: #000000;
          margin-left: 2px;
        }
      }

      .form-control {
        width: 516px;
        flex-shrink: 0;

        .form-input,
        .form-select {
          width: 100%;

          ::v-deep .el-input__inner {
            border-radius: 10px;
            border: 1px solid #DCE6F5;
            background: #FFFFFF;
            font-family: 'Inter', 'PingFang SC', sans-serif;
            font-size: 14px;
            color: #1D2129;
            height: 38px;
            line-height: 38px;

            &::placeholder {
              color: #8C9BB4;
            }
          }
        }
      }
    }

    .form-row-num {
      padding-left: 24px;
      .form-label { width: 86px; }
    }

    .form-row-type {
      padding-left: 24px;
      .form-label { width: 86px; }
    }

    .form-row-remark {
      padding-left: 64px;
      .form-label { width: 46px; }
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 0 24px 28px;

    .cancel-btn {
      width: 98px;
      height: 38px;
      border-radius: 10px;
      border: 1px solid #0E76FF;
      background: #FFFFFF;
      color: #0E76FF;
      font-family: 'PingFang SC', sans-serif;
      font-weight: 500;
      font-size: 14px;
      padding: 0;

      &:hover {
        background: #E8F3FF;
      }
    }

    .confirm-btn {
      width: 98px;
      height: 38px;
      border-radius: 10px;
      border: none;
      background: #0E76FF;
      color: #FFFFFF;
      font-family: 'PingFang SC', sans-serif;
      font-weight: 500;
      font-size: 14px;
      padding: 0;

      &:hover {
        background: #1C99FF;
      }
    }
  }
</style>
